module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/maddie-francess-60972ece84ddbf1bcf5901b0cceac52a.jpg";